<template>
	<wt-selector :multiple="true" :options="organizationRoleType" v-model="Value" :allowCreate="true" :filterable="true" clearable="true"></wt-selector>
</template>
<script>
import { organizationRoleType } from 'json/customer-options'
export default{
  name: 'agent-selector',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      Value: this.value,
      organizationRoleType: organizationRoleType
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {

  },
  created () {
  }
}
</script>
